import { createSlice } from "@reduxjs/toolkit";


const initialState: any = {
    driver: [],
    loading: false,
    error: null,
  };
const maintenanceSlice = createSlice({
    name: "maintenance",
    initialState,
    reducers: {
        maintenanceRequest(state) {
        state.loading = true;
        state.error = null;
      },
      maintenanceSuccess(state, action) {
        state.loading = false;
        state.maintenance = action.payload;
      },
      maintenanceAddSuccess(state, action) {
        state.loading = false;
        state.maintenance.push(action.payload);
      },
      maintenanceEditSuccess(state, action) {
        state.loading = false;
        state.maintenance = state.maintenance.map((maintenance: { id: any; }) =>
          maintenance.id === action.payload.id ? action.payload : maintenance
        );
      },
      maintenanceDeleteSuccess(state, action) {
        state.loading = false;
        state.maintenance = state.maintenance.filter((maintenance: { id: any; }) => maintenance.id !== action.payload);
      },
      maintenanceError(state, action) {
        state.loading = false;
        state.error = action.payload;
      },
      getMaintenanceByIdRequest(state) {
        state.loading = true;
        state.error = null;
      },
      getMaintenanceByIdSuccess(state, action) {
        state.loading = false;
        state.user = action.payload;  // Store the user fetched by ID in `user`
      },
      getMaintenanceByIdError(state, action) {
        state.loading = false;
        state.error = action.payload;
      },
    },
  });

  export const {
      maintenanceRequest,
      maintenanceSuccess,
      maintenanceAddSuccess,
      maintenanceEditSuccess,
      maintenanceDeleteSuccess,
      maintenanceError,
      getMaintenanceByIdRequest,
      getMaintenanceByIdSuccess,
      getMaintenanceByIdError
  } = maintenanceSlice.actions;

export default maintenanceSlice.reducer;
  